import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["centerAlign", "children"];
import { View } from 'foundations-components/components/View';
import styled from 'foundations-theming/utils';
import { devices } from '../../styles/viewports.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentWrapper = styled.div.withConfig({
  displayName: "Content__ContentWrapper"
})(["block-size:100%;display:grid;flex-grow:1;grid-template-rows:1fr auto;margin-inline:auto;inline-size:80%;@media ", "{", "}"], devices.desktop, props => !props.centerAlign && `padding-left: 4%;`);
export const Content = _ref => {
  let {
      centerAlign = false,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(View, Object.assign({
    paddingBlockStart: centerAlign ? '800' : '0',
    paddingBlockEnd: '800',
    blockSize: "100%",
    overflowY: "auto",
    flexGrow: 1
  }, props, {
    children: /*#__PURE__*/_jsx(ContentWrapper, {
      centerAlign: centerAlign,
      children: children
    })
  }));
};